import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import headerImage from "../../assets/images/headerImage.png";
import cardOne from "../../assets/images/cardOne.png";
import cardTwo from "../../assets/images/cardTwo.png";
import cardThree from "../../assets/images/cardThree.png";
import easyToUse from "../../assets/images/easyToUse.png";
import eventsData from "../../component/dummyData";
import ForBusinessesImage from "../../assets/images/ForBusinesses.png";
import ForVolunteersImage from "../../assets/images/ForVolunteers.png";
import ForFamiliesImage from "../../assets/images/ForFamilies.png";
import illustrationVolunteers from "../../assets/images/illustrationVolunteers.png";
import illustrationFamily from "../../assets/images/illustrationFamily.png";
import illustrationBusiness from "../../assets/images/illustrationBusiness.png";
import sponsorOne from "../../assets/images/svgs/sponsorOne.svg";
import sponsorTwo from "../../assets/images/svgs/sponsorTwo.svg";
import sponsorThree from "../../assets/images/svgs/sponsorThree.svg";
import sponsorFour from "../../assets/images/svgs/sponsorFive.svg";
import sponsorFive from "../../assets/images/svgs/sponsorSix.svg";
import sponsorSix from "../../assets/images/svgs/sponsorSeven.svg";
import LetsConnect from "../../component/lets-connect";
import logo from "../../assets/images/logo.png";
import tiktokIcon from "../../assets/images/svgs/tiktok.svg";
import youtubeIcon from "../../assets/images/svgs/youtube.svg";
import instagramIcon from "../../assets/images/svgs/instagram.svg";
import facebookIcon from "../../assets/images/svgs/facebook.svg";
import appStore from "../../assets/images/svgs/appStore.svg";
import googlePlay from "../../assets/images/svgs/googlePlay.svg";
import bgFixed from "../../assets/images/bgFixed.png";
import Navbar from "../../component/navbar/Navbar";
import EventExploreSlider from "../../component/eventsSlider";
import LaunchingSoonModal from "../../component/popup";
import { useNavigate } from "react-router-dom";
import TermsAndCondition from "../../component/drawers/TermsAndCondtion";
import PrivacyPolicy from "../../component/drawers/PrivacyPolicy";
import { WEB_APP_URL } from "../../utils/enums/constants";

const Home = () => {
  const [showModal, setShowModal] = useState(false);
  const [drawerOpenTerms, setDrawerOpenTerms] = useState(false);
  const [drawerOpenPrivacy, setDrawerOpenPrivacy] = useState(false);

  const toggleTerms = () => setDrawerOpenTerms((prev) => !prev);
  const togglePrivacy = () => setDrawerOpenPrivacy((prev) => !prev);

  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <div>
      <Navbar />

      <section id="home" className="bg-primary">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center justify-center lg:justify-start gap-4 py-6">
            {/* Left Content */}
            <div className="flex flex-col gap-1 animate-slide-right">
              <h1 className="text-primaryText text-3xl sm:text-5xl animate-fade-in">
                Strengthening Communities Through Learning
              </h1>
              <p className="text-lg text-blueText leading-relaxed mt-4 animate-fade-in">
                Learn Local supports local businesses in hosting real-world
                educational experiences for kids in their community. Learn Local
                is where businesses grow, kids learn, and communities connect.
              </p>

              <div className="flex items-center flex-wrap gap-2 mt-6 animate-fade-in">
                <button className="bg-darkBg px-6 py-3 text-lg text-white rounded-md hover:bg-secondaryText transition-colors duration-300 ease-in-out">
                  <a href={`${WEB_APP_URL}/auth/login`}>
                    Join Now
                  </a>
                </button>

                <button
                  onClick={() => {
                    const el = document.getElementById("exploreEvents");
                    if (el) {
                      el.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                  className="bg-lightBg px-6 py-3 text-lg text-white hover:bg-secondaryText rounded-md"
                >
                  Explore
                </button>
              </div>
            </div>

            {/* Right Image */}
            <div className=" flex justify-center lg:flex-none animate-slide-left">
              <img
                className="w-full sm:w-[90%] "
                src={headerImage}
                alt="headerImage"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Section Three Cards */}
      <section id="cards" className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 py-6">
          {/* Card One */}
          <div
            className="flex flex-col items-center justify-center gap-4 p-4 rounded-[25px] border border-primaryBorder w-fit"
            data-aos="fade-up"
          >
            <span>
              <img
                className="w-[340px] h-[270px] rounded-[25px]"
                src={cardOne}
                alt="cardOne"
              />
            </span>
            <h1 className="text-yellowDark text-2xl tracking-wider">
              For Families
            </h1>
            <p className="text-lightText text-center text-base">
              Discover fun, engaging sessions tailored to your child’s interests
              and needs—right in your neighborhood.
            </p>
          </div>

          {/* Card Two */}
          <div
            className="flex flex-col items-center justify-center gap-4 p-4 rounded-[25px] border border-primaryBorder w-fit"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <span>
              <img
                className="w-[340px] h-[270px] rounded-[25px]"
                src={cardTwo}
                alt="cardTwo"
              />
            </span>
            <h1 className="text-yellowDark text-2xl tracking-wider">
              For Businesses
            </h1>
            <p className="text-lightText text-center text-base">
              Turn your expertise into a powerful educational experience that
              connects you with the community and builds brand loyalty.
            </p>
          </div>

          {/* Card Three */}
          <div
            className="flex flex-col items-center justify-center gap-4 p-4 rounded-[25px] border border-primaryBorder w-fit"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <span>
              <img
                className="w-[340px] h-[270px] rounded-[25px]"
                src={cardThree}
                alt="cardThree"
              />
            </span>
            <h1 className="text-yellowDark text-2xl tracking-wider">
              For Volunteers
            </h1>
            <p className="text-lightText text-center text-base">
              Gain hands-on leadership and community engagement experience while
              making a real difference.
            </p>
          </div>
        </div>
      </section>

      {/* Easy to Use */}
      <section id="exploreApp" className="bg-primary">
        <div className="container">
          <div
            className="flex flex-col items-center justify-center gap-6 py-6"
            data-aos="fade-up"
          >
            <h1 className="text-darkText text-3xl md:text-5xl">
              Easy to Use,{" "}
              <span className="text-secondaryText">Fun to Explore!</span>
            </h1>

            {/* Cards */}
            <div
              className="flex flex-wrap xl:flex-nowrap justify-center items-center gap-4 py-2 md:py-10"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="flex flex-col content-center items-center justify-center gap-2">
                {/* Step 1 */}
                <div
                  className="flex flex-col gap-2 bg-white p-4 sm:p-8 border border-primaryBorder rounded-[25px] text-center w-full sm:w-[350px] h-au sm:h-[200px]"
                  data-aos="flip-left"
                >
                  <h2 className="text-xl font-semibold text-secondaryText">
                    STEP 1:
                  </h2>
                  <p className="text-darkText font-semibold mt-[-8px]">
                    Download the App
                  </p>
                  <p className="text-sm text-blueText">
                    Get started in minutes by downloading our user-friendly app.
                  </p>
                </div>

                {/* Step 2 */}
                <div
                  className="flex flex-col gap-2 bg-white p-4 sm:p-8 border border-primaryBorder rounded-[25px] text-center w-full sm:w-[350px] h-au sm:h-[200px]"
                  data-aos="flip-left"
                  data-aos-delay="100"
                >
                  <h2 className="text-xl font-semibold text-secondaryText">
                    STEP 2:
                  </h2>
                  <p className="text-darkText font-semibold mt-[-8px]">
                    Create or Find Sessions
                  </p>
                  <p className="text-sm text-blueText">
                    Businesses can create workshops with our simple guide, and
                    families can browse sessions that fit their interests.
                  </p>
                </div>
              </div>

              {/* Image */}
              <div data-aos="zoom-in">
                <img className="" src={easyToUse} alt="headerImage" />
              </div>

              {/* Steps 3 & 4 */}
              <div className="flex flex-col gap-2">
                {/* Step 3 */}
                <div
                  className="flex flex-col gap-2 bg-white p-4 sm:p-8 border border-primaryBorder rounded-[25px] text-center w-full sm:w-[350px] h-au sm:h-[200px]"
                  data-aos="flip-right"
                >
                  <h2 className="text-xl font-semibold text-secondaryText">
                    STEP 3:
                  </h2>
                  <p className="text-darkText font-semibold mt-[-8px]">
                    Engage and Learn
                  </p>
                  <p className="text-sm text-blueText">
                    Attend fun, educational experiences in your local community
                    and keep the learning going at home!
                  </p>
                </div>

                {/* Step 4 */}
                <div
                  className="flex flex-col gap-2 bg-white p-4 sm:p-8 border border-primaryBorder rounded-[25px] text-center w-full sm:w-[350px] h-au sm:h-[200px]"
                  data-aos="flip-right"
                  data-aos-delay="100"
                >
                  <h2 className="text-xl font-semibold text-secondaryText">
                    STEP 4:
                  </h2>
                  <p className="text-darkText font-semibold mt-[-8px]">
                    Earn and Grow
                  </p>
                  <p className="text-base text-lightText">
                    Volunteers and ambassadors earn points, gain skills, and
                    connect with others through our incentive programs
                  </p>
                </div>
              </div>
            </div>

            <div data-aos="zoom-in">
              <button
                // onClick={() => setShowModal(true)}
                className="bg-darkBg px-6 py-3 text-lg text-white rounded-md hover:bg-secondaryText transition-colors duration-300 ease-in-out"
              >
                Try it Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Explore Events */}
      <section id="exploreEvents">
        {/* Explore Events */}
        <EventExploreSlider />
      </section>

      {/* For Businesses */}
      <section id="business" className="bg-primary overflow-hidden">
        <div className="container">
          <div className="flex items-center justify-between gap-4 flex-wrap lg:flex-nowrap my-6">
            <div className="flex flex-col gap-2" data-aos="fade-right">
              <h1 className="text-primaryText text-3xl sm:text-5xl flex items-center gap-2">
                For
                <span className="text-secondaryText">Businesses</span>
              </h1>
              <p className="text-xl font-bold text-black leading-relaxed mt-4">
                Grow connections and gain visibility in the community.
              </p>
              <ul className="list-disc list-inside">
                <li className="text-lightText text-xl">
                  Templates and guides for creating sessions
                </li>
                <li className="text-lightText text-xl">
                  Tools to customize experiences for diverse learners
                </li>
              </ul>

              <div className="mt-6">
                <button
                  // onClick={() => setShowModal(true)}
                  className="bg-darkBg px-6 py-3 text-lg text-white rounded-md hover:bg-secondaryText transition-colors duration-300 ease-in-out"
                >
                  <a href={`${WEB_APP_URL}/auth/sign-up?role=HOST`}>
                    Join as a Business
                  </a>
                </button>
              </div>
            </div>
            <div data-aos="fade-up-left">
              <img src={ForBusinessesImage} alt="headerImage" />
            </div>
          </div>
        </div>
      </section>

      {/* For Families */}
      <section id="families" className="overflow-hidden">
        <div className="container">
          <div
            className="flex items-center justify-between gap-4 flex-wrap lg:flex-nowrap my-6"
            data-aos=""
          >
            <div className="flex flex-col gap-2" data-aos="fade-right">
              <h1 className="text-primaryText text-3xl sm:text-5xl flex items-center gap-2">
                For
                <span className="text-secondaryText">Families</span>
              </h1>
              <p className="text-xl font-bold text-black leading-relaxed mt-4">
                Build skills and confidence in a fun, hands-on way.
              </p>
              <ul className="list-disc list-inside">
                <li className="text-lightText text-xl">
                  Easy browsing by age, interest, or skill level
                </li>
                <li className="text-lightText text-xl">
                  Personalized session recommendations
                </li>
              </ul>

              <div className="mt-6">
                <button className="bg-darkBg px-6 py-3 text-lg text-white rounded-md hover:bg-secondaryText transition-colors duration-300 ease-in-out">
                  <a href={`${WEB_APP_URL}/auth/sign-up?role=ATTENDEE`}>
                    Join as an Attendee
                  </a>
                </button>
              </div>
            </div>
            <div data-aos="fade-up-left">
              <img src={ForFamiliesImage} alt="ForFamiliesImage" />
            </div>
          </div>
        </div>
      </section>

      {/* For Volunteers */}
      <section id="volunteers" className="bg-primary overflow-hidden">
        <div className="container">
          <div className="flex items-center justify-center lg:justify-between gap-4 flex-wrap lg:flex-nowrap my-6">
            <div className="flex flex-col gap-2" data-aos="fade-right">
              <h1 className="text-primaryText text-3xl sm:text-5xl flex items-center gap-2">
                For
                <span className="text-secondaryText">Volunteers</span>
              </h1>
              <p className="text-xl font-bold text-black leading-relaxed mt-4">
                Develop leadership skills and gain real-world experience.
              </p>
              <ul className="list-disc list-inside">
                <li className="text-lightText text-xl">
                  Engaging dashboard to track hours, earn points, and redeem
                  rewards
                </li>
                <li className="text-lightText text-xl">
                  Have fun while making a difference
                </li>
              </ul>

              <div className="mt-6">
                <button
                  // onClick={() => setShowModal(true)}
                  className="bg-darkBg px-6 py-3 text-lg text-white rounded-md hover:bg-secondaryText transition-colors duration-300 ease-in-out"
                >
                  <a href={`${WEB_APP_URL}/auth/ambassador-role`}>
                    Become an Ambassador
                  </a>
                </button>
              </div>
            </div>
            <div data-aos="fade-up-left">
              <img src={ForVolunteersImage} alt="ForVolunteersImage" />
            </div>
          </div>
        </div>
      </section>

      {/* Section Illustration Cards */}
      <section id="" className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 py-6 items-center">
          {/* Card 1 */}
          <div
            className="flex flex-col items-center justify-center gap-4 p-4 rounded-[25px] border border-primaryBorder"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <span>
              <img
                className=""
                src={illustrationFamily}
                alt="illustration Family"
              />
            </span>
            <h1 className="text-darkText text-2xl tracking-wider uppercase">
              For Families
            </h1>
            <p className="text-lightText text-center text-base">
              Find enriching experiences for your <br /> children.
            </p>
            <div className="mt-3">
              <button
             
                className="bg-darkBg px-6 py-3 text-lg text-white rounded-md hover:bg-secondaryText transition-colors duration-300 ease-in-out"
              >
                <a href={`${WEB_APP_URL}/auth/sign-up?role=ATTENDEE`}>
                  Join as an Attendee
                </a>
              </button>
            </div>
          </div>

          {/* Card 2 */}
          <div
            className="flex flex-col items-center justify-center gap-4 p-4 rounded-[25px] border border-primaryBorder"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <span>
              <img
                className=""
                src={illustrationBusiness}
                alt="illustration Business"
              />
            </span>
            <h1 className="text-darkText text-2xl tracking-wider uppercase">
              For Businesses
            </h1>
            <p className="text-lightText text-center text-base">
              Sign up to create sessions and connect with <br /> your community.
            </p>
            <div className="mt-3">
              <button className="bg-darkBg px-6 py-3 text-lg text-white rounded-md hover:bg-secondaryText transition-colors duration-300 ease-in-out">
                  <a href={`${WEB_APP_URL}/auth/sign-up?role=HOST`}>
                    Join as a Host
                  </a>
              </button>
            </div>
          </div>

          {/* Card 3 */}
          <div
            className="flex flex-col items-center justify-center gap-4 p-4 rounded-[25px] border border-primaryBorder"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <span>
              <img
                className=""
                src={illustrationVolunteers}
                alt="illustration Volunteers"
              />
            </span>
            <h1 className="text-darkText text-2xl tracking-wider uppercase">
              For Volunteers
            </h1>
            <p className="text-blueText text-center text-base">
              Join our leadership program and make an <br /> impact!
            </p>
            <div className="mt-3">
              <button
                // onClick={() => setShowModal(true)}
                className="bg-darkBg px-6 py-3 text-lg text-white rounded-md hover:bg-secondaryText transition-colors duration-300 ease-in-out"
              >
                  <a href={`${WEB_APP_URL}/auth/ambassador-role`}>
                    Join as an Ambassador
                  </a>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div
          className="relative bg-fixed bg-cover bg-center h-[65vh]"
          style={{ backgroundImage: `url(${bgFixed})` }}
        >
          {/* Add a semi-transparent overlay with opacity */}
          <div className="absolute inset-0 bg-black opacity-50 z-10" />

          {/* Content centered inside */}
        </div>
      </section>

      {/* section Our SPONSORS */}
      <section id="sponsor" className="container">
        <div className="flex flex-col gap-10">
          <h1 className="text-primaryText text-3xl sm:text-5xl flex items-center gap-2">
            Our
            <span className="text-secondaryText">Partners</span>
          </h1>
          <ul className="flex flex-wrap sm:flex-nowrap justify-between gap-6 sm:gap-20 px-8">
            <li className="w-full sm:w-1/2 list-disc  text-lightText text-lg">
              We are incredibly grateful for the generous support of our
              sponsors. Their contributions make it possible for us to continue
              our mission and create a meaningful impact within our community.
            </li>
            <li className="w-full sm:w-1/2 list-disc text-lightText text-lg">
              By partnering with us, these businesses have shown their
              commitment to fostering growth and learning opportunities.
            </li>
          </ul>
          <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 mx-auto sm:mx-0 my-0 sm:my-4">
            <img className="w-[138px]" src={sponsorOne} alt="sponsor One" />
            <img className="w-[138px]" src={sponsorTwo} alt="sponsor One" />
            <img className="w-[138px]" src={sponsorThree} alt="sponsor One" />
            <img className="w-[138px]" src={sponsorFour} alt="sponsor One" />
            <img className="w-[138px]" src={sponsorFive} alt="sponsor One" />
            <img className="w-[138px]" src={sponsorSix} alt="sponsor One" />
          </div>
        </div>
      </section>

      {/* Let’s Connect! */}
      <section id="contact" className="bg-primary">
        <div className="container">
          <div className="flex flex-wrap lg:flex-nowrap justify-center lg:justify-between gap-10">
            <div className="lg:w-1/2 flex flex-col gap-8">
              <div className="flex items-center gap-4">
                <img className="w-36" src={logo} alt="logo" />
              </div>
              <p className="text-lightText text-lg">
                Together, we can support every business, inspire every child,
                and connect every community.
              </p>
              <div className="flex flex-col gap-4">
                <span className="text-lightText text-lg ">
                  Follow our journey on social media
                </span>
                <div className="flex items-center gap-4">
                  <img
                    className="cursor-pointer"
                    src={tiktokIcon}
                    alt="tiktok"
                  />
                  <img
                    className="cursor-pointer"
                    src={youtubeIcon}
                    alt="youtubeIcon"
                  />
                  <img
                    className="cursor-pointer"
                    src={instagramIcon}
                    alt="instagramIcon"
                  />
                  <img
                    className="cursor-pointer"
                    src={facebookIcon}
                    alt="facebookIcon"
                  />
                </div>
              </div>
              {/* <div className="flex items-center gap-8">
                <img src={googlePlay} alt="googlePlay" />

                <img src={appStore} alt="appStore" />
              </div> */}
            </div>
            <div>
              <LetsConnect />
            </div>
          </div>
          <div className="flexf justify-center mt-10">
            <ul className="flex flex-wrap justify-center gap-4 sm:gap-10 ">
              <li className="text-blueText">
                ©Learn Local. All Right Reserved
              </li>
              <li
                onClick={toggleTerms}
                className="text-blueText cursor-pointer"
              >
                Terms of Use
              </li>
              <li
                onClick={togglePrivacy}
                className="text-blueText cursor-pointer"
              >
                Privacy Policy
              </li>
            </ul>
          </div>
        </div>
      </section>
      {showModal && (
        <LaunchingSoonModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
        />
      )}

      {drawerOpenTerms && (
        <TermsAndCondition isOpen={setDrawerOpenTerms} onClose={toggleTerms} />
      )}

      {drawerOpenPrivacy && (
        <PrivacyPolicy isOpen={setDrawerOpenPrivacy} onClose={togglePrivacy} />
      )}
    </div>
  );
};

export default Home;
